import React, { ReactNode } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import path from '../../routesCustom'
import LoaderToLazy from '../LoaderToLazy'
import { useVerifyingAccess } from '../../hooks/verifying-access-hook'

const PREV_ROUTE_KEY = 'redirectPreviousUrl'
interface PrivateRouteInterface {
  children: ReactNode
}

export const PrivateRoute = ({ children }: PrivateRouteInterface) => {
  const { gotToLogin, isVerifying, accessDenied } = useVerifyingAccess()
  const history = useHistory()
  const { hash, pathname, search } = useLocation()

  const pageValidated = () => {
    if (isVerifying) {
      return <LoaderToLazy />
    }

    if (accessDenied) {
      history.replace(path.publicPath.HOME)
      localStorage.setItem(PREV_ROUTE_KEY, `${pathname}${hash}${search}`)
      history.push(gotToLogin)
      return
    }
    return children
  }

  return <>{pageValidated()}</>
}

PrivateRoute.defaultProps = {
  children: <></>,
}
